/* Fork Instinct: product-card colour thumbnails (snippets/fi-card-thumbs.liquid).
   Event delegation, so cards added by infinite scroll / filtering work too. */
(() => {
  if (window.__fiCardThumbs) return;
  window.__fiCardThumbs = true;

  const THUMB = '.fi-cthumbs .fi-cthumb';

  function cardOf(el) {
    return el.closest('product-card') || el.closest('.product-card');
  }

  function galleryOf(card) {
    return card && card.querySelector('.card-gallery');
  }

  // Show the thumb's image over the card gallery (or remove the overlay for the initial colour).
  function showImage(thumb) {
    const card = cardOf(thumb);
    const gallery = galleryOf(card);
    if (!gallery) return;
    let overlay = gallery.querySelector(':scope > .fi-cthumb-ov');
    if (thumb.dataset.initial === 'true') {
      if (overlay) overlay.hidden = true;
      return;
    }
    if (!overlay) {
      overlay = document.createElement('img');
      overlay.className = 'fi-cthumb-ov';
      overlay.alt = '';
      overlay.decoding = 'async';
      overlay.setAttribute('aria-hidden', 'true');
      gallery.appendChild(overlay);
    }
    if (overlay.dataset.src !== thumb.dataset.src) {
      const w = Math.round(gallery.getBoundingClientRect().width) || 400;
      overlay.sizes = w + 'px';
      if (thumb.dataset.srcset) overlay.srcset = thumb.dataset.srcset;
      overlay.src = thumb.dataset.src;
      overlay.dataset.src = thumb.dataset.src;
    }
    overlay.hidden = false;
  }

  // Point the card's own product links at the chosen variant.
  function updateLinks(card, variantId) {
    const links = card.querySelectorAll('a[href]:not(.fi-cthumb)');
    links.forEach((a) => {
      if (!a.dataset.fiHref) {
        // Only links to this card's product (gallery, title, overlay link)
        const ref = a.getAttribute('ref');
        if (!(ref === 'productCardLink' || ref === 'cardGalleryLink' || ref === 'productTitleLink')) return;
        a.dataset.fiHref = a.getAttribute('href');
      }
      const url = new URL(a.dataset.fiHref, location.origin);
      if (variantId) url.searchParams.set('variant', variantId);
      else url.searchParams.delete('variant');
      a.setAttribute('href', url.pathname + url.search + url.hash);
    });
  }

  function select(thumb) {
    const strip = thumb.closest('.fi-cthumbs');
    const card = cardOf(thumb);
    if (!strip || !card) return;
    strip.querySelectorAll('.fi-cthumb').forEach((t) => {
      const on = t === thumb;
      t.classList.toggle('is-active', on);
      if (t.tagName === 'BUTTON') t.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    showImage(thumb);
    updateLinks(card, thumb.dataset.initial === 'true' ? null : thumb.dataset.variant);
    if (card.dataset.featuredMediaUrl !== undefined && thumb.dataset.src) {
      card.dataset.featuredMediaUrl = thumb.dataset.src;
    }
  }

  function restore(strip) {
    const active = strip.querySelector('.fi-cthumb.is-active') || strip.querySelector('.fi-cthumb[data-initial="true"]');
    if (active) showImage(active);
  }

  // Hover (mouse / pen): colour thumbs select; sibling thumbs preview.
  document.addEventListener('pointerover', (e) => {
    if (e.pointerType === 'touch') return;
    const thumb = e.target.closest && e.target.closest(THUMB);
    if (!thumb) return;
    const strip = thumb.closest('.fi-cthumbs');
    if (strip.dataset.mode === 'colors') select(thumb);
    else showImage(thumb);
  });

  document.addEventListener(
    'pointerleave',
    (e) => {
      const strip = e.target;
      if (!(strip instanceof Element) || !strip.matches('.fi-cthumbs')) return;
      if (strip.dataset.mode === 'siblings') restore(strip);
    },
    true
  );

  // Click / tap. Captured at the document so the card's own click handling doesn't run.
  document.addEventListener(
    'click',
    (e) => {
      const thumb = e.target.closest && e.target.closest(THUMB);
      if (!thumb) return;
      e.stopPropagation();
      if (thumb.tagName === 'BUTTON') {
        e.preventDefault();
        select(thumb);
      }
      // Sibling thumbs are real links: let the browser follow them.
    },
    true
  );

  // Keyboard focus mirrors hover.
  document.addEventListener('focusin', (e) => {
    const thumb = e.target.closest && e.target.closest(THUMB);
    if (!thumb) return;
    const strip = thumb.closest('.fi-cthumbs');
    if (strip.dataset.mode === 'colors') select(thumb);
    else showImage(thumb);
  });

  document.addEventListener('focusout', (e) => {
    const strip = e.target.closest && e.target.closest('.fi-cthumbs');
    if (!strip || strip.dataset.mode !== 'siblings') return;
    if (e.relatedTarget && strip.contains(e.relatedTarget)) return;
    restore(strip);
  });
})();